import React, { useContext, useState, useEffect } from "react";
const getSavedAddresses = () => {
  try {
    const data = localStorage.getItem('scc_addressbook');
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};
import Title from "../components/Title";
import CartTotal from "../components/CartTotal";
import { assets } from "../assets/assets";
import { ShopContext } from "../context/ShopContext";
import { data } from "react-router-dom";
import axios, { Axios } from "axios";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet';

// Static country/flag/code list
const countryList = [
  { name: "India", code: "+91", flag: "🇮🇳" }
];

const PlaceOrder = () => {
  const [method, setMethod] = useState("cod");
  const { navigate , backendUrl,token,cartItems,setCartItems,getCartAmount,delivery_fee,products,userInfo } = useContext(ShopContext);
  const userName = userInfo.name.split(" ");
  const [firstName, lastName] = userName.length > 1 ? userName : [userName[0], ""];
  const [formData, setFormData] = useState({
    firstName: firstName,
    lastName: lastName,
    email: userInfo.email,
    street: "",
    city: "",
    state: "",
    zipCode: "",
    country: "India",
    phone: "",
  });
  const [savedAddresses, setSavedAddresses] = useState(getSavedAddresses());
  const [showAddressList, setShowAddressList] = useState(false);

  useEffect(() => {
    setSavedAddresses(getSavedAddresses());
  }, []);
  // Removed location loading and error state
  const [phoneCountryCode] = useState(countryList[0].code);

  const onChangeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  // Removed detect location handler

  const onSubmitHandler  = async (event) =>{
    event.preventDefault();
    try {
      
      let orderItems = []

      for(const items in cartItems){
        for(const item in cartItems[items]){
          if (cartItems[items][item] > 0) {
            const itemInfo = structuredClone(products.find(product => product._id === items));
            if (itemInfo) {
              itemInfo.size = item;
              let entry = cartItems[items][item];
              itemInfo.color = typeof entry === 'object' ? entry.color : null;
              itemInfo.measurements = typeof entry === 'object' ? entry.measurements : null;
              orderItems.push(itemInfo);
            }
          }
        }
      }

      let orderData = {
        address: formData,
        items: orderItems,
        amount: getCartAmount() + delivery_fee
      }

      switch (method) {
        case 'cod': {
          const response = await axios.post(backendUrl + '/api/order/place',orderData,{headers:{token}});
          if (response.data.success) {
            setCartItems({});
            localStorage.removeItem('cartItems');
            navigate('/user/orders/success');
          }else{
            toast.error(response.data.message);
          }
          break;
        }
        case 'stripe': {
          const responseStripe = await axios.post(backendUrl + '/api/order/stripe',orderData,{headers:{token}});
          if (responseStripe.data.success) {
            const {session_url} = responseStripe.data;
            window.location.replace(session_url)
          }else{
            toast.error(responseStripe.data.message);
          }
          break;
        }
        default:
          break;
      }
      

    } catch (error) {
      toast.error(error.message)
      
    }
  }

  return (
    <>
    <Helmet>
      <title>Place Order</title>
    </Helmet>
    <form onSubmit={onSubmitHandler} className="flex flex-col sm:flex-row justify-between gap-4 pt-5 sm:pt-14 min-h[80vh] border-t">
      {/*---------------------------Left Side--------------------------- */}
      <div className="flex flex-col gap-4 w-full sm:max-w-[480px]">
        <div className="text-xl sm:text-2xl my-3">
          <Title text1={"DELIVERY"} text2={"INFORMATION"} />
        </div>
        {savedAddresses.length > 0 ? (
          <div className="mb-4">
            <div className="mb-2 text-xs text-gray-500 font-semibold">Choose a saved address:</div>
            <div className="flex flex-col gap-2">
              {savedAddresses.map((a, idx) => (
                <button
                  key={idx}
                  type="button"
                  className={`flex items-start gap-3 border rounded-tremor-small px-3 py-2 transition-all text-left hover:border-tremor-brand focus:border-tremor-brand bg-white dark:bg-dark-tremor-background ${formData.street === a.street && formData.city === a.city && formData.zipCode === a.zip ? 'border-tremor-brand ring-2 ring-tremor-brand' : 'border-gray-200'}`}
                  onClick={() => {
                    setFormData(fd => ({
                      ...fd,
                      firstName: a.name.split(' ')[0] || '',
                      lastName: a.name.split(' ').slice(1).join(' '),
                      phone: a.phone,
                      street: a.street,
                      city: a.city,
                      state: a.state,
                      zipCode: a.zip,
                      country: 'India',
                    }));
                  }}
                >
                  <div className="flex-1 min-w-0">
                    <div className="font-medium text-sm text-tremor-content-strong dark:text-dark-tremor-content-strong truncate flex items-center gap-2">
                      {a.isDefault && <span className="text-xs bg-tremor-brand text-white px-2 py-0.5 rounded">Default</span>}
                      <span className="truncate">{a.name}</span>
                    </div>
                    <div className="text-xs text-gray-500 dark:text-gray-400">{a.phone}</div>
                    <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{a.street}, {a.city}, {a.state}, {a.country} {a.zip}</div>
                  </div>
                  <span className="ml-2 text-xs text-tremor-brand font-bold self-center">{formData.street === a.street && formData.city === a.city && formData.zipCode === a.zip ? 'Selected' : 'Select'}</span>
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className="mb-2 text-xs text-gray-500 bg-yellow-50 border border-yellow-200 rounded-tremor-small p-2">
            No saved addresses found. Add an address in your <span className="font-semibold">Account Settings &gt; Address Book</span> for quick checkout.
          </div>
        )}
        <div className="flex gap-3">
          <input
            required
            onChange={onChangeHandler}
            name="firstName"
            value={formData.firstName}
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
            type="text"
            placeholder="First Name"
          />
          <input
            required
            onChange={onChangeHandler}
            name="lastName"
            value={formData.lastName}
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
            type="text"
            placeholder="Last Name"
          />
        </div>
        <input
          required
          onChange={onChangeHandler}
          name="email"
          value={formData.email}
          className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
          type="email"
          placeholder="Email Address"
        />
        <input
          required
          onChange={onChangeHandler}
          name="street"
          value={formData.street}
          className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
          type="text"
          placeholder="Street"
        />
        <div className="flex gap-3">
          <input
            required
            onChange={onChangeHandler}
            name="city"
            value={formData.city}
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
            type="text"
            placeholder="City"
          />
          <input
            required
            onChange={onChangeHandler}
            name="state"
            value={formData.state}
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
            type="text"
            placeholder="State"
          />
        </div>
        <div className="flex gap-3">
          <input
            required
            onChange={onChangeHandler}
            name="zipCode"
            value={formData.zipCode}
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
            type="number"
            placeholder="Zipcode"
          />
          {/* Country - fixed to India, uneditable */}
          <input
            name="country"
            value="India"
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full bg-gray-100 text-gray-800 font-medium cursor-not-allowed"
            type="text"
            readOnly
            tabIndex={-1}
          />
        </div>
        {/* Phone with fixed code, no dropdown, no nation name */}
        <div className="flex gap-3 items-center">
          <span className="border border-gray-300 rounded py-1.5 px-2 w-20 bg-gray-100 text-gray-800 font-semibold text-lg select-none cursor-not-allowed flex items-center justify-center">🇮🇳 +91</span>
          <input
            required
            onChange={onChangeHandler}
            name="phone"
            value={formData.phone}
            className="border border-gray-300 rounded py-1.5 px-3.5 w-full"
            type="number"
            placeholder="Phone Number"
          />
        </div>
        {/* Detect My Location Button removed */}
      </div>
      {/**---------------------------Right Side--------------------------- */}
      <div className="mt-8">
        <div className="mt-8 min-w-80">
          <CartTotal />
        </div>
        <div className="mt-12">
          <Title text1={"PAYMENT"} text2={"METHOD"} />
          {/**---------------------------Payment Method------------------- */}
          <div className="flex gap-3 flex-col lg:flex-row">
            <div
              onClick={() => setMethod("stripe")}
              className="flex items-center gap-3 border p-2 px-3 cursor-pointer"
            >
              <p
                className={`min-w-3.5 h-3.5 border rounded-full ${
                  method === "stripe" ? "bg-green-400" : ""
                }`}
              ></p>
              <img className="h-5 mx-4" src={assets.stripe_logo} alt="" />
            </div>
            <div
              onClick={() => toast.warn("Razorpay is not available,try stripe")}
              className="flex items-center gap-3 border p-2 px-3 cursor-pointer opacity-50"
            >
              <p
                className={`min-w-3.5 h-3.5 border rounded-full ${
                  method === "razorpay" ? "bg-green-400" : ""
                }`}
              ></p>
              <img className="h-5 mx-4" src={assets.razorpay_logo} alt="" />
            </div>
            <div
              onClick={() => setMethod("cod")}
              className="flex items-center gap-3 border p-2 px-3 cursor-pointer"
            >
              <p
                className={`min-w-3.5 h-3.5 border rounded-full ${
                  method === "cod" ? "bg-green-400" : ""
                }`}
              ></p>
              <p className="text-gray-500 text-sm font-medium mx-4">
                CASH ON DELIVERY
              </p>
            </div>
          </div>

          <div className="w-full text-end mt-8">
            <button
              type="submit"
              
              className="bg-black text-white px-16 py-3 text-sm"
            >
              PLACE ORDER
            </button>
          </div>
        </div>
      </div>
    </form>
    </>
  );
};

export default PlaceOrder;
